import ScheduleNotification from '../../../../widgets/trip-notification/components/ScheduleNotification';
import { getScheduleNotificationContent } from '../../../../utils/notification';
import type { TripChange } from '../../models';

interface ScheduleChangeNotificationProps {
  tripChange: TripChange;
}

const ScheduleChangeNotification = ({ tripChange }: ScheduleChangeNotificationProps) => {
  return Array.isArray(tripChange.schedule) ? (
    <ScheduleNotification
      content={getScheduleNotificationContent(tripChange)}
      dataTestId="paymentPage-scheduleNotification-TripNotification"
    />
  ) : null;
};

export default ScheduleChangeNotification;
